import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductList.css';
import ShareButton from './ShareButton';

function ProductList({ products }) {
  const navigate = useNavigate();

  const handleViewDetails = (productId) => {
    navigate(`/product/${productId}`);
  };

  return (
    <div className="product-list">
      {products.length === 0 ? (
        <p className="no-products">No products found</p>
      ) : (
        <div className="products-grid">
          {products.map(product => (
            <div key={product.id} className="product-card">
              <img
                src={product.image_urls?.[0] || 'placeholder.jpg'}
                alt={product.title}
                className="product-image"
              />
              <div className="product-info">
                <h3 className="product-title">{product.title}</h3>
                  <p className="product-price">₹{Math.trunc(Number(product.price || 0))}</p>
                <p className="product-condition">Condition: {product.condition}</p>
                <p className="product-location">{product.locality}, {product.city}</p>
                {/* <p className="seller-info">Seller: {product.username}</p> */}
                <div className="product-card-actions">
                  <button className="view-btn" onClick={() => handleViewDetails(product.id)}>View Details</button>
                  <ShareButton product={product} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProductList;
